import React, { Component } from "react";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { getConfigTable } from "./config";

class ProspectTodayTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableConfig: [],
            dataTable: [],
            dataTL: [],
            teamLead: null,
        };
    };

    componentDidMount = async () => {
        this.setState((prevValue) => ({
          ...prevValue,
          tableConfig: getConfigTable(this.props.tab),
          dataTable: [],
        }));
    };

    componentDidUpdate(prevProps, prevState) {
        const {search: prevSearch} = prevProps;
        const { search: propsSearch } = this.props;
        if (this.props.search.kodeCabang && JSON.stringify(prevSearch) !== JSON.stringify(propsSearch)) {
            this.fetchData();
        }
    }

    handleSearchValueChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async () => {
      this.props.triggerLoading();
      const userId = localStorage.getItem("userId");
      let resUser = await Api.create("NAGAMAS_MASTER_DATA").getUserProfile({
        idUser: userId,
      });
      const salesId = resUser.data.data.employeeId
      try {
        let res = null;
        if (this.props.tab === "prospek") {
          res = await this.fetchDataProspekToday(salesId);
        } else if (this.props.tab === "appointmentFU") {
          res = await this.fetchDataAppointmentFUToday(salesId);
        } else if (this.props.tab === "appointmentOD") {
          res = await this.fetchDataAppointmentOD(salesId);
        }
        this.setState((prev) => ({
          ...prev,
          dataTable: res,
        }));
        this.props.resetSearch()
        this.props.triggerLoading();
      } catch (error) {
        this.props.triggerLoading();
      }
    };

    fetchDataProspekToday = async(salesId) =>{
        try {
            const res = await fetchDataAsync({
              asyncFn:
                Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikToday,
              menuName: "Dashboard Salesman/CS CRM - Laporan Statistik Daily",
              setError: this.props.setError,
              args: {
                kodeCabang: this.props.search.kodeCabang,
                teamLeaderEmployeeId: this.props.search.teamLead,
                // leadId: null,
                // salesId: salesId
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                return res.data.data
            }
            throw Error("Error Fetching Data")
        } catch (error) {
            throw Error(error)
        }
    }

    fetchDataAppointmentFUToday = async(salesId) =>{
      console.log(this.props.search?.teamLead);
      console.log(salesId);
      
        try {
            const res = await fetchDataAsync({
              asyncFn:
                Api.create("NAGAMAS_REPORT_DTO").getLaporanAppointmentFUToDay,
              menuName: "Dashboard Salesman/CS CRM - Laporan Statistik Daily",
              setError: this.props.setError,
              args: {
                kodeCabang: this.props.search?.kodeCabang,
                teamLeaderEmployeeId: this.props.search?.teamLead !== salesId ? null : this.props.search?.teamLead,
                salesId: this.props.search?.teamLead == salesId ? null : salesId
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                console.log(res.data.data)
                return res.data.data
            }
            throw Error("Error Fetching Data")
        } catch (error) {
            throw Error(error)
        }
    }

    fetchDataAppointmentOD = async(salesId) =>{
        try {
            const res = await fetchDataAsync({
              asyncFn:
                Api.create("NAGAMAS_REPORT_DTO").getLaporanAppointmentOverdue,
              menuName: "Dashboard Salesman/CS CRM - Laporan Statistik Daily",
              setError: this.props.setError,
              args: {
                kodeCabang: this.props.search?.kodeCabang,
                teamLeaderEmployeeId: this.props.search?.teamLead !== salesId ? null : this.props.search?.teamLead,
                salesId: this.props.search?.teamLead == salesId ? null : salesId
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                return res.data.data
            }
            throw Error("Error Fetching Data")
        } catch (error) {
            throw Error(error)
        }
    }

    render() {
        return (
          <>
            <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
              {`Laporan ${
                this.props.tab === "prospek"
                  ? "Statistik Prospek Today"
                  : this.props.tab === "appointmentFU"
                  ? "Appintment Followup Hari Ini"
                  : "Appintment Overdue"
              }`}
            </p>
            <SimpleDataTable
              data={this.state.dataTable}
              columns={this.state.tableConfig}
              // options={{ pagination: false }}
            />
          </>
        );
    };
}

export default ProspectTodayTab;